import { useDisclosure } from '@chakra-ui/hooks';

import { ContactUs } from '@/components/ui/shared/sections/ContactUs/ContactUs';
export const LandingFreeTrial = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return <ContactUs isOpen={isOpen} onOpen={onOpen} onClose={onClose} />;
};
